import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4mwr31tr64: FaireBrandEntity = {
  token: "b_4mwr31tr64",
  type: "brand",
  name: "Timeless Skin Care",
  avatarUrl:
    "https://cdn.faire.com/fastly/20c81e31522945336a21c1a19974580c8da81d3337bcf424ffde8a1e7701b298.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/c4ff76fab363423a89ac0cb64cf6d81a9b8781f397d72e84ef04ad035fbc1477.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/20c81e31522945336a21c1a19974580c8da81d3337bcf424ffde8a1e7701b298.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c4ff76fab363423a89ac0cb64cf6d81a9b8781f397d72e84ef04ad035fbc1477.jpeg",
  location: "Stafford, TX, USA",
  minimumOrderDollars: 100,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "Timeless Skin Care is dedicated to creating advanced skin care solutions with exceptional quality and value. Each product is carefully designed and crafted to promote vibrant, healthy skin. With high concentrations of clinically studied, active ingredients, Timeless Skin Care serums and specialty products boost skin health, reverse the signs of aging, and protect from future damage. Our clean, simple formulas can be used alone or incorporated into any skin care routine for added benefits.\n\nWe believe in the art of simplicity. Our products are made in the USA in small batches to guarantee freshness and potency, without unnecessary fillers, chemicals and fragrances - only the Good Stuff!",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:25.897Z",
    importedBy: "entity-db-cli",
  },
};
